import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
import ScrollToTop from './componenten/ScrollToTop';


//Pagina componenten
import Navbar from "./navbar/navbar";
import Footer from "./footer/footer";
import Home from "./home/home";
import Overons from './over-ons/over-ons';
import Projecten from './projecten/projecten';
import Contact from './contact/contact';
import AlgVoorwaarden from './alg-voorwaarden/alg-voorwaarden';

//Project componenten
import EMotionChair from './projecten/emotionchair/emotionchair';
import Coinfc from './projecten/coinfc/coinfc';
import DesignThinking from './projecten/designthinking/designthinking';


function App() {
  return (
    <div className="App">
        <Router>
          <ScrollToTop />
          
          <Navbar />

          <Routes>
            {/* Pagina routes */}
            <Route path="/" element={<Home />} />
            <Route path="/overons" element={<Overons />} />
            <Route path="/projecten" element={<Projecten />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/algemene-voorwaarden" element={<AlgVoorwaarden />} />

            {/* Project routes */}
            {/* <Route path="/emotionchair" element={<EMotionChair />} />
            <Route path="/coinfc" element={<Coinfc />} />
            <Route path="/designthinking" element={<DesignThinking  />} /> */}
          </Routes>

          <Footer />
        </Router>

    </div>
  );
}

export default App;
